import React from 'react';

import '../../MainApp.scss';

const Header = ({ title = '', subtitle = '', children }) => {


    return (
        <div className='dash-main-header'>

            <div className='dash-main-header-left'>
                {/* {subtitle
                    ? <div className="dash-main-header-title"><span className='dash-main-header-slash'>/</span> {title} <span className='dash-main-header-slash'>/</span> {subtitle}</div>
                    : <div className="dash-main-header-title"><span className='dash-main-header-slash'>/</span> {title}</div>
                } */}
                <div className="dash-main-header-title">
                    <span className='dash-main-header-slash'>/</span>
                </div>
            </div>
            <div className='dash-main-header-right'>
                {children}

                {/* <button className='dash-main-header-button'>Search</button> */}
                {/* <button className='dash-main-header-button'></button> */}


                {/* <button className='dash-main-header-button secondary'>
                    Import SQL
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9L12 15L18 9"></path></svg>
                </button>
                <button className='dash-main-header-button prime' onClick={(e) => { handleClick(e); }}>Create Diagram</button> */}
            </div>

        </div>
    );
};

export default Header;
